import styled, { css } from 'styled-components';

import { Text } from '@gympass/yoga';

import { TabContainerProps, TabState } from './types';

export const TabAmount = styled(Text.H3)``;

export const TabText = styled(Text.Small)``;

const Tab = css<TabContainerProps>`
  display: inline-flex;
  padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  opacity: ${({ state }) => (state === TabState.DISABLED ? 0.5 : 1)};
  box-shadow: ${({ theme }) => theme.yoga.elevations.small};
  cursor: ${({ state }) =>
    state === TabState.INACTIVE ? 'pointer' : 'not-allowed'};

  background-color: ${({ theme, state }) =>
    state === TabState.ACTIVE
      ? theme.yoga.colors.primaryLight
      : theme.yoga.colors.white};

  > * {
    color: ${({ theme, state }) =>
      state !== TabState.ACTIVE
        ? theme.yoga.colors.primaryLight
        : theme.yoga.colors.white};

    > b {
      color: ${({ theme, state }) =>
        state !== TabState.ACTIVE
          ? theme.yoga.colors.primaryLight
          : theme.yoga.colors.white} !important;
      font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
    }
  }
`;

export const LargeTab = styled.div<TabContainerProps>`
  ${Tab}
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border-radius: ${({ theme }) => theme.yoga.radii.regular}px;
`;

export const SmallTab = styled.div<TabContainerProps>`
  ${Tab}
  display: flex;
  justify-content: center;
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
`;
